
import { debounce } from 'lodash';
import { mapState, mapActions } from 'vuex';
import graphemeLength from '@/lib/graphemeLength';
import AiKeywords from './AiKeywords.vue';

export default {
  i18nComponentKey: 'ReviewsNew.components.ReviewMessageInput',
  name: 'ReviewMessageInput',
  components: {
    AiKeywords
  },
  props: {
    value: { type: String, default: '' },
    rows: { type: Number, default: 5 },
    maxlength: { type: Number, default: 2000 },
    invalid: { type: Boolean, default: false },
    fieldConfig: { type: Object, required: true },
    validMessageLength: { type: Number, required: true },
    hasAiKeywordReward: { type: Boolean, default: false }
  },
  computed: {
    ...mapState(['api']),
    ...mapState('reviewSettings', ['reviewSettings']),
    ...mapState('form', ['formValues']),
    aiKeywords() {
      if (!this.fieldConfig.ai_keywords) return [];

      const matchedKeywords = this.formValues.matched_ai_keywords || [];

      return this.fieldConfig.ai_keywords.map(e => ({
        keyword: e,
        matched: matchedKeywords.includes(e)
      }));
    },
    isAiKeywordEnabled() {
      return (
        this.fieldConfig.enable_ai_keyword &&
        this.fieldConfig.ai_keywords.length > 0
      );
    },
    valueLength() {
      return graphemeLength(this.value);
    }
  },
  watch: {
    value(newValue) {
      this.debouncedFetchKeywordsAnalysis(newValue);
    }
  },
  created() {
    this.debouncedFetchKeywordsAnalysis = debounce(
      this.fetchKeywordsAnalysis.bind(this),
      1000
    );
  },
  beforeDestroy() {
    this.debouncedFetchKeywordsAnalysis.cancel();
  },
  methods: {
    ...mapActions('form', ['setFieldValue']),
    fetchKeywordsAnalysis(message) {
      if (!this.isAiKeywordEnabled) return;

      this.api
        .fetchKeywordsAnalysis(message, this.fieldConfig.ai_keywords)
        .then(({ data }) => {
          this.setFieldValue({
            key: 'matched_ai_keywords',
            value: Object.keys(data.results).filter(e => data.results[e] === 1)
          });
        });
    }
  }
};
